import React from 'react';
import { Box, Typography, Button, Paper, alpha, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const GlassPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 24,
  backdropFilter: 'blur(16px)',
  background: alpha(theme.palette.background.paper, 0.7),
  border: '1px solid rgba(255, 255, 255, 0.1)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  overflow: 'hidden',
}));

const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  borderRadius: 12,
  padding: '10px 24px',
  fontWeight: 600,
  transition: 'all 0.3s ease',
  '&:hover': {
    background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
    transform: 'translateY(-3px)',
    boxShadow: `0 10px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
  },
}));

const GradientText = styled(Typography)(({ theme }) => ({
  fontWeight: 800,
  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

function NotFound() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ 
      mt: 4, 
      textAlign: 'center', 
      maxWidth: 600, 
      mx: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
    }}>
      <GlassPaper sx={{ p: 6 }}>
        <GradientText variant="h1" component="h1" sx={{ fontSize: '8rem', lineHeight: 1 }}>
          404
        </GradientText>
        
        <Typography variant="h4" component="h2" gutterBottom fontWeight="bold" sx={{ mt: 2 }}>
          Page Not Found
        </Typography>
        
        <Typography variant="body1" paragraph color="text.secondary" sx={{ mb: 4 }}>
          The page you are looking for doesn't exist or has been moved.
        </Typography>
        
        <GradientButton
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
        >
          Back to Home
        </GradientButton>
      </GlassPaper>
      
      <Box 
        sx={{ 
          position: 'absolute',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.2)}, transparent)`,
          filter: 'blur(40px)',
          top: '30%',
          left: '20%',
          zIndex: -1,
        }} 
      />
      
      <Box 
        sx={{ 
          position: 'absolute',
          width: '250px',
          height: '250px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${alpha(theme.palette.secondary.main, 0.2)}, transparent)`,
          filter: 'blur(40px)',
          top: '40%',
          right: '20%',
          zIndex: -1,
        }} 
      />
    </Box>
  );
}

export default NotFound;
